import axios from 'axios';
import config from '../../config';


const baseUrl = config.baseUrl + '/api/novedad_participante';

const headers = {
  'Content-Type': 'application/json',
};

export const getAllNovedades = async () => {
  const response = await axios.get(baseUrl, { headers });
  return response.data;
};

export const getNovedadById = async (oid) => {
  const response = await axios.get(`${baseUrl}/${oid}`, { headers });
  return response.data;
};

export const createNovedad = async (formData) => {
  const response = await axios.post(`${baseUrl}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const updateNovedad = async (oid, formData) => {
  const response = await axios.put(`${baseUrl}/${oid}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteNovedad = async (oid, novedad, usuario) => {
  const response = await axios.delete(`${baseUrl}/${oid}`, {
    data: { usuario, novedad },
  });
  return response.data;
};

export const getDepartamentos = async () => {
  const response = await axios.get(`${baseUrl}/departamentos`, { headers });
  return response.data;
};

export const getMunicipios = async () => {
  const response = await axios.get(`${baseUrl}/municipios`, { headers });
  return response.data;
};

export const getParticipantes = async () => {
  const response = await axios.get(`${baseUrl}/participantes`, { headers });
  return response.data;
};


export const getParticipantesEditar = async (participanteId) => {
  const response = await axios.get(`${baseUrl}/participantes_editar`, {
    headers,
    params: { participanteId },
  });
  return response.data;
};